<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
            </div>
          </div>
          <div id="details" class="row">
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.name)"
                  >
                    <label>Name</label>
                    <input
                      type="text"
                      minlength="3"
                      maxlength="20"
                      name="name"
                      class="form-control"
                      required
                      v-model.lazy="tempuser.name"
                      placeholder="Name"
                    />
                    <field-messages
                      name="technicianName"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Operator name is a required field</div>
                      <div slot="pattern">Operator Name is invalid</div>
                      <div slot="minlength">
                        Technician name should be more than 3 characters
                      </div>
                      <div slot="maxlength">
                        Technician name should be less than 20 characters
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.mobileNumber)"
                  >
                    <label>Mobile Number</label>
                    <input
                      type="number"
                      min="1000000000"
                      name="mobileNumber"
                      class="form-control"
                      required
                      v-model.lazy="tempuser.mobileNumber"
                      placeholder="Mobile number"
                      pattern="[78965][0-9]{9}"
                    />
                    <field-messages
                      name="mobileNumber"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Mobile number is a required field</div>
                      <div slot="pattern">Mobile number is invalid</div>
                      <div slot="min">Minimum 10 digit</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.dateOfBirth)"
                  >
                    <label>Date of Birth</label>
                    <date-picker
                      :max="this.minDate"
                      id="dateOfBirth"
                      required
                      v-model="tempuser.dateOfBirth"
                      lang="en"
                      name="dateOfBirth"
                      input-class="form-control"
                      width="100%"
                      use-utc="true"
                      format="DD-MM-YYYY"
                      @change="getEligibleDate"
                    ></date-picker>
                    <field-messages
                      name="dateOfBirth"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Date of Birth is a required field</div>
                      <div slot="max">Mimimum Age is 18 years</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.deviceId)"
                  >
                    <label>Device</label>
                    <select
                      v-model="tempuser.deviceId"
                      required
                      name="deviceId"
                      class="form-control"
                    >
                      <option value="" disabled>Select Device</option>
                      <option
                        v-for="(item, index) in device_id"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="deviceId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Device is a required field</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.region)"
                  >
                    <label>Geographical Area</label>
                    <select
                      v-model="tempuser.region"
                      :disabled="isGADisable"
                      required
                      name="region"
                      class="form-control"
                    >
                      <option value="" disabled>Select G.A</option>
                      <option
                        v-for="(item, index) in region_list"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="region"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">G.A is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.manager)"
                  >
                    <label>Journey Manager</label>
                    <select
                      v-model="tempuser.manager"
                      :disabled="isJourenyManagerDisable"
                      required
                      name="manager"
                      class="form-control"
                    >
                      <option value="" disabled>Select Journey Manager</option>
                      <option
                        v-for="(item, index) in manager"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="manager"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Journey Manager is a required field</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.languageKnown)"
                  >
                    <label>Language Known</label>
                    <select
                      v-model="tempuser.languageKnown"
                      required
                      name="languageKnown"
                      class="form-control"
                    >
                      <option value="" disabled>Select Language</option>
                      <option
                        v-for="(item, index) in language"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="languageKnown"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Language is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.defaultLanguage)"
                  >
                    <label>Default Language</label>
                    <select
                      v-model="tempuser.defaultLanguage"
                      required
                      name="defaultLanguage"
                      class="form-control"
                    >
                      <option value="" disabled>Select Language</option>
                      <option
                        v-for="(item, index) in language"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.userPin)"
                  >
                    <label>Operator Pin</label>
                    <input
                      type="number"
                      min="1000"
                      max="9999"
                      name="technicianPin"
                      class="form-control"
                      required
                      v-model.lazy="tempuser.userPin"
                      placeholder="Operator Pin"
                    />
                    <field-messages
                      name="technicianPin"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Operator pin is a required field</div>
                      <div slot="pattern">Operator pin is invalid</div>
                      <div slot="min">Operator pin is minimum 4 digit</div>
                      <div slot="max">Operator pin is Maximum 4 digit</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    class="form-group"
                    :class="fieldClassName(formstate.addressDetails)"
                  >
                    <label>Address</label>
                    <textarea
                      class="form-control"
                      name="addressDetails"
                      v-model.lazy="tempuser.addressDetails"
                      placeholder="Address"
                    >
                    </textarea>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.status)"
                  >
                    <label>Status</label>
                    <select
                      required
                      v-model.lazy="tempuser.status"
                      name="status"
                      class="form-control"
                    >
                      <option value="" disabled>Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                    <field-messages
                      name="status"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Status is a required field</div>
                      <div slot="pattern">Status is invalid</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.userType)"
                  >
                    <label>Type</label>
                    <select
                      required
                      v-model="tempuser.userType"
                      name="type"
                      class="form-control"
                    >
                      <option value="" disabled>Select Type</option>
                      <option value="operator">Operator</option>
                    </select>
                    <field-messages
                      name="userType"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Type is a required field</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.site)"
                  >
                    <label>Location</label>
                    <select
                      v-model="tempuser.site"
                      required
                      name="endSite"
                      class="form-control"
                    >
                    <option value="" disabled>Select Location</option>
                      <option
                        v-for="(item, index) in site_name"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="site"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Location is a required field</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'Technician' }">
                <button class="mr-5 btn btn-default" type="button">Cancel</button>
              </router-link>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="createTechnician"
                :disabled="!(formstate.$dirty && formstate.$valid)"
              >
                Add Operator
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Config, { USER_ROLES } from "../../../config";
import { formService, eventBus, technicianService } from "../../../services";
import { EVENTS } from "../../../config";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "TechnicianCreate",
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: false,
      flash: false,
      isGADisable: false,
      isJourenyManagerDisable: false,
      flashType: null,
      flashMessage: "",
      EVENTS: EVENTS,
      formstate: {},
      manager: {},
      region_list: {},
      device_id: {},
      site_name: {},
      minDate: "",
      tempuser: {
        site: '',
        userType: "",
        manager: '',
        deviceId: '',
        languageKnown: '',
        defaultLanguage: '',
        status: "active",
      },
      language: [
        {
          key: "Hindi",
          value: "Hindi",
        },
        {
          key: "Punjabi",
          value: "Punjabi",
        },
        {
          key: "English",
          value: "English",
        },
      ],
    };
  },
  mounted: function () {
    this.getManagerList();
    this.getRegionList();
    this.getDevice();
    this.getSite();
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    getEligibleDate(e) {
      let d = new Date();
      d.setMonth(d.getMonth() - 12 * 18);
      this.minDate = d;
    },
    getSite() {
      this.loading = true;
      const params = {};
      if (this.user.roleName == "Journey Manager") {
        params.regionJourneyManager = `["${this.user._id}"]`;
      }
      params.$limit = 0;
      //params.roleRank = 4;
      let siteList = [];
      this.$siteDataRepository
        .list(params)
        .then((res) => {
          this.loading = false;
          if (res.data.docs) {
            siteList = res.data.docs.map((item) => {
              return {
                key: item._id,
                value: item.siteName,
              };
            });
          }
          this.site_name = siteList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("site.requestFunction-error:", error);
          this.$snotify.error("Get site list failed", "Error!");
        });
    },

    getDevice() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      //params.roleRank = 4;
      let deviceList = [];
      this.$deviceDataRepository
        .list(params)
        .then((res) => {
          this.loading = false;
          if (res.data.docs) {
            deviceList = res.data.docs.map((item) => {
              return {
                key: item._id,
                value: item.deviceId,
              };
            });
          }
          this.device_id = deviceList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("device.requestFunction-error:", error);
          this.$snotify.error("Get device list failed", "Error!");
        });
    },
    getRegionList() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.user.roleName == "GA Head") {
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == "Journey Manager") {
        params.journeyManager = `["${this.user._id}"]`;
        this.isGADisable = true;
      }
      let regionlist = [];
      this.$regionDataRepository
        .list(params)
        .then((res) => {
          this.loading = false;
          if (res.data.docs) {
            regionlist = res.data.docs.map((item) => {
              return {
                key: item._id,
                value: item.name,
              };
            });
          }
          this.region_list = regionlist;
          this.user.roleName == "Journey Manager"
            ? (this.tempuser.region = this.region_list[0].key)
            : (this.tempuser.region = "");
        })
        .catch((error) => {
          this.loading = false;
          console.error("Region.requestFunction-error:", error);
          this.$snotify.error("Get region list failed", "Error!");
        });
    },
    getManagerList() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 3;
      let managerlist = [];
      if (this.user.roleName == "Journey Manager") {
        params._id = `["${this.user._id}"]`;
        this.isJourenyManagerDisable = true;
        this.tempuser.manager = this.user._id;
      }
      this.$userRepository
        .list(params)
        .then((res) => {
          this.loading = false;
          if (res.data.docs) {
            managerlist = res.data.docs.map((item) => {
              return {
                key: item._id,
                value: item.firstName + " " + item.lastName,
              };
            });
          }
          this.manager = managerlist;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Manager.requestFunction-error:", error);
          this.$snotify.error("Get manager list failed", "Error!");
        });
    },
    createTechnician() {
      this.loading = true;
      return technicianService
        .addTechnician(this.tempuser)
        .then((response) => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success("Technician added!", "Success!");
          this.$router.push("/operator");
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error("Technician Add failed! Try Again", "Error!");
          console.log("error", error);
          if (error.data.message.includes("must be one of")) {
            this.flash = true;
            this.flashType = "error";
            this.flashMessage = "New Technician add is failed.Please try again!";
          }
        });
    },
    fieldClassName: function (field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
};
</script>
<style scoped>
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
}
.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}
.has-danger {
  color: red;
}
.mt {
  margin-top: 7px;
}
.expiryClass {
  background-color: red;
}
.gradientbt {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white;
}
</style>



// WEBPACK FOOTER //
// TechnicianCreate.vue?8a5fb292